// extracted by mini-css-extract-plugin
export var container = "index-module--container--5oUpm";
export var fixedHeader = "index-module--fixedHeader--aeIvG";
export var hCentered = "index-module--hCentered--rquRV";
export var headerAndMain = "index-module--headerAndMain--TEM60";
export var main = "index-module--main--Fw+WE";
export var noPadding = "index-module--noPadding--QiCXp";
export var vCentered = "index-module--vCentered--mVW3i";